module.exports = __webpack_public_path__ + "static/media/12.0507f09c.png";